export const MUSIC_VOLUME = 'MUSIC_VOLUME';
export const SOUND_EFFECT_VOLUME = 'SOUND_EFFECT_VOLUME';
export const ON_MUTE = 'ON_MUTE';